import { useEffect, useState, useContext } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Modal from "react-modal";

import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import { LineProgressBar, ControlButton } from './components/controls';
import { Pages } from './components/pages';
import { InitPage, TotalPage } from './data/Data';
import { GetDataPost } from './data/Help';
import http from '../../services/http';
import { endPoints } from '../../utils/constanst';

import './CVS_Digital.css';

const CVS_Digital = () => {
    const { loading } = useToken();

    useEffect(() => {
        setTimeout(() => {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }, 600);
    }, []);

    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/cvs/" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ location }: IPropsParam) => {
    const [index, setIndex] = useState(InitPage);
    const [validParm, setValidParam] = useState(false);
    const [idBizagiTemp, setIdBizagiTemp] = useState('' as string | null);
    const [idClientTemp, setIdClientTemp] = useState('' as string | null);
    const [loading, setLoading] = useState(false);
    const textNext: string = (index == 4) ? 'Enviar' : 'Siguiente';
    const { CVS, setCVS, changeHandler } = useContext(DataContext);

    useEffect(() => {
        let searchParams = new URLSearchParams(location.search);
        let idBizagi = searchParams.get('IDBizagi');
        let idClient = searchParams.get('IDCliente');
        setIdBizagiTemp(idBizagi);
        setIdClientTemp(idClient);
    }, []);

    useEffect(() => {
        if ((idBizagiTemp != undefined && idBizagiTemp != null && idBizagiTemp != '') && (idClientTemp != undefined && idClientTemp != null && idClientTemp != ''))
            setValidParam(true);
        else
            setValidParam(false);

    }, [idBizagiTemp, idClientTemp]);

    const Submit = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        if (result == null)
            return;
        if (!result.reportValidity())
            return;
        switch (index) {
            case 0:
                setCVS({ ...CVS, IDBizagi: idBizagiTemp, IDCliente: idClientTemp });
                Increment();
                break;
            case 3:
                UpdateBizagi();
                break;
            default:
                Increment();
        }
    }

    const Decrement = () => (index !== 0) ? setIndex(index - 1) : 0;
    const Increment = () => (index <= TotalPage) ? setIndex(index + 1) : 0;

    const UpdateBizagi = () => {
        let data = GetDataPost(CVS);
        setLoading(true);
        http(endPoints.UpdateInsureBizagi)
            .post(data)
            .then((response: string) => {
                console.log(response);
                setCVS({ ...CVS, saved: true });
                Increment();
            })
            .catch((error: string) => {
                console.log(error);
                Increment();
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <div className="container">
            <div className="layout-cvs">
                <div className="mt-10">
                    <p className="lbl-encabezado1 mb-10">
                        Protección para la inversión más importante de tu vida
                    </p>
                    <p className="lbl-encabezado2 mt-0 mb-30">
                        Para la formalización de tu crédito debes contar con tu seguro de vida saldo deudor
                    </p>
                </div>
                <LineProgressBar index={(index < TotalPage ? index + 1 : TotalPage)} totalPages={TotalPage} />
                <form>
                    <Pages index={index} />
                    <ControlButton indexPage={index}>
                        {index !== 0 &&
                            <button
                                className={`control-button-btn-cvs prev`}
                                type="button"
                                onClick={Decrement}
                            >
                                Regresar
                            </button>
                        }
                        {
                            <button
                                className="control-button-btn-cvs next"
                                type="button"
                                onClick={Submit}
                            >
                                {textNext}
                            </button>
                        }
                    </ControlButton>
                </form>
            </div>
            <Modal className="modal" isOpen={!validParm} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Falta parametros de IdBizagi o IdCliente</p>
                </div>
            </Modal>
            <Modal className="modal" isOpen={loading} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Cargando...</p>
                </div>
            </Modal>
        </div>
    );
}

export default CVS_Digital;